import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SharedModule } from '../shared/shared.module';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ButtonListComponent } from './button-list/button-list.component';
import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ChipListSelectComponent } from './chip-list-select/chip-list-select.component';
import { ChipListComponent } from './chip-list/chip-list.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { FormLabelDirective } from './directives/form-label.directive';
import { InputViewComponent } from './input-view/input-view.component';
import { InputComponent } from './input/input.component';
import { MultipleSelectOutputComponent } from './multiple-select-output/multiple-select-output.component';
import { PromptComponent } from './prompt/prompt.component';
import { QuestionStateService } from './question-state.service';
import { QuestionComponent } from './question/question.component';
import { RichTextInputComponent } from './rich-text-input/rich-text-input.component';
import { SelectComponent } from './select/select.component';
import { TextareaComponent } from './textarea/textarea.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { MtxNativeDatetimeModule } from '@ng-matero/extensions/core';

@NgModule({
    declarations: [
        PromptComponent,
        QuestionComponent,
        ButtonListComponent,
        ButtonComponent,
        InputComponent,
        TextareaComponent,
        CheckboxComponent,
        DatePickerComponent,
        SelectComponent,
        RichTextInputComponent,
        ChipListSelectComponent,
        AutocompleteComponent,
        FormLabelDirective,
        MultipleSelectOutputComponent,
        ChipListComponent,
        DateRangePickerComponent,
        InputViewComponent,
        DateTimePickerComponent
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatTooltipModule,
        SharedModule,
        MatIconModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        TextFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatChipsModule,
        MatListModule,
        MatCheckboxModule,
        DragDropModule,
        MatExpansionModule,
        CKEditorModule,
        RouterModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MtxDatetimepickerModule,
        MtxNativeDatetimeModule
    ],
    exports: [
        InputComponent,
        TextareaComponent,
        CheckboxComponent,
        DatePickerComponent,
        SelectComponent,
        RichTextInputComponent,
        ChipListSelectComponent,
        AutocompleteComponent,
        FormLabelDirective,
        MultipleSelectOutputComponent,
        QuestionComponent,
        ButtonComponent,
        ButtonListComponent
    ],
    providers: [QuestionStateService, DatePipe, MatDatepickerModule, MtxDatetimepickerModule]
})
export class UcrFormsModule {}
